import { EyeIcon } from "components/Icons";
import { useTable } from "storev2/tableStore";
import { cn } from "tools/ui";

import ModalEvents from "./ModalEvents";

function ButtonEvents({ record }) {
  const { openModalTable } = useTable();

  function onClick(e) {
    e.stopPropagation();
    openModalTable(ModalEvents, { record }, "staff.access.view_events");
  }

  return (
    <button
      type="button"
      onClick={onClick}
      title="Ver novedades"
      className={cn(
        "flex mx-auto items-center justify-center",
        "size-7 rounded-md border border-cyan-600 bg-cyan-600 text-white",
        "hover:bg-cyan-700 active:scale-95 cursor-pointer transition",
      )}
    >
      <EyeIcon className="size-4 fill-current" />
    </button>
  );
}

export default ButtonEvents;